// js
import { connect } from 'react-redux';
import KeyGoalsCard from '../../components/goals/KeyGoalsCard';
import { makeGetIsActiveArea } from '../../selectors/dsa/areaSelectors';
import { makeGetAreaGoalsProgress } from '../../selectors/dsa/goalsSelectors';


const mapStateToProps = (state, props) => {
  const getIsActiveArea = makeGetIsActiveArea();
  const getAreaGoalsProgress = makeGetAreaGoalsProgress();

  return {
    isActiveArea: getIsActiveArea(state, props),
    progress: getAreaGoalsProgress(state, props)
  };
};

export default connect(mapStateToProps)(KeyGoalsCard);



// WEBPACK FOOTER //
// ./src/containers/goals/KeyGoalsCard.js